import InputType from "common/form/InputType";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";
import { Form, Input } from "decorator-form";

const viewsInput = ButtonSelect.registerWithOptions([
	{value: 'block', label: 'Block'},
	{value: 'heading', label: 'Heading'},
	{value: 'typography', label: 'Typogrophy'},
	{value: null, label: "None"}
]);

@Form({title: "Text Panel Config"})
export default class TextPanelConfig {

	// @Input({type: InputType.CHECKBOX, title: "Wrap in Block View"})
	// Depricated, keep and check to avoid updating configs
	public useBlockView?: boolean;

	@Input({type: viewsInput, title: "View Wrapper"})
	public view: "block" | "heading" | "typography";

	@Input({type: InputType.TEXTAREA, title: "Default Text"})
	public body: string;

	@Input({
		type: InputType.TEXT,
		title: "Label Key",
		description: "Define a custom label key. BEWARE: this can collide with other labels in the site."
	})
	public labelKey: string;

}



// WEBPACK FOOTER //
// ./src/panels/text/TextConfig.ts